import React, {createContext, useState} from "react";

// create contexts with default values
export const LocationContext = createContext()

export function useTicketLocation() {
    const [ticketLocation, setTicketLocation] = useState();
    return [ticketLocation, setTicketLocation];
}
